const DOCUMENT_REQUIRED_STATUS = {
  UPLOADED: "uploaded",
  PENDING: "pending",
  INCIDENCE: "incidence",
  VALIDATED: "validated",
};

const DOCUMENT_REQUIRED = {
  DOCUMENT_ID_FRONT: "document_id_front",
  DOCUMENT_ID_BACK: "document_id_back",
  PASSPORT: "passport",
  BIOMETRICS_DOCUMENT: "biometrics_document",
  KYC_VIDEO: "kyc_video",
  BANK_READER_INCOME: "bank_reader_income",
  BORROWER_BANK_READER: "borrower_bank_reader",
};

const REQUIRED_DOCUMENTS_ALWAYS_EXCLUDED = [
  DOCUMENT_REQUIRED.BIOMETRICS_DOCUMENT,
  DOCUMENT_REQUIRED.KYC_VIDEO,
  DOCUMENT_REQUIRED.BANK_READER_INCOME,
  DOCUMENT_REQUIRED.BORROWER_BANK_READER,
];

const REQUIRED_DOCUMENTS_EXCLUDED_IF_NOT_UNRESOLVED_STATUS = [
  DOCUMENT_REQUIRED.DOCUMENT_ID_FRONT,
  DOCUMENT_REQUIRED.DOCUMENT_ID_BACK,
  DOCUMENT_REQUIRED.PASSPORT,
  DOCUMENT_REQUIRED.BANK_READER_INCOME,
];

const UNRESOLVED_STATUS = [
  DOCUMENT_REQUIRED_STATUS.PENDING,
  DOCUMENT_REQUIRED_STATUS.INCIDENCE,
];

const documentMustBeExcludedIfNotUnresolved = (doc) =>
  REQUIRED_DOCUMENTS_EXCLUDED_IF_NOT_UNRESOLVED_STATUS.includes(doc.name);

const documentStatusIsAllowed = (doc) => UNRESOLVED_STATUS.includes(doc.status);

const filterAlwaysExcludedDocuments = (docs) =>
  docs?.filter(
    (requiredFile) =>
      !REQUIRED_DOCUMENTS_ALWAYS_EXCLUDED.includes(requiredFile.name)
  );

const filterResolvedDocuments = (docs) =>
  docs?.filter((requiredFile) => {
    if (
      (documentMustBeExcludedIfNotUnresolved(requiredFile) &&
        documentStatusIsAllowed(requiredFile)) ||
      !documentMustBeExcludedIfNotUnresolved(requiredFile)
    ) {
      return requiredFile;
    }
  });

export const DocumentationRequiredMapper = {
  hydrate(data) {
    return {
      ...data,
      required_files: data.required_files,
    };
  },
  filterEditableRequiredDocuments(data) {
    return {
      ...data,
      required_files: filterResolvedDocuments(
        filterAlwaysExcludedDocuments(data.required_files)
      ),
    };
  },
};
